import script from "./Apply_agent.vue?vue&type=script&setup=true&lang=js"
export * from "./Apply_agent.vue?vue&type=script&setup=true&lang=js"

import "./Apply_agent.vue?vue&type=style&index=0&id=040c4c1e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-040c4c1e"]])

export default __exports__